<template lang="html">
  <div class="contPrincipal" v-if="open">
    <div class="nuevaCont">
    <img src="../../assets/iconos/cerrarB.png" v-on:click="cerrar" alt="">
      <div class="itemForm">
        <p>Categoría</p>
        <select name="" id="">
          <option value=""></option>
          <option value="">Escuela</option>
          <option value="">Trabajo</option>
          <option value="">Casa</option>
          <option value="">Hobbies</option>
        </select>
      </div>

      <div class="itemForm">
        <p>Tipo</p>
        <select name="" id="">
          <option value=""></option>
          <option value="">Evento</option>
          <option value="">Tarea</option>
          <option value="">Notas</option>
        </select>
      </div>

      <div class="itemForm">
        <p>Nombre</p>
        <input type="text" />
      </div>

      <div class="itemForm">
        <p>Fecha</p>
        <input type="date" name="date" id="" />
      </div>

      <button type="submit" v-on:click="cerrar">Guardar</button>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      open: this.$store.state.nuevoRegistro,
    };
  },
  components: {},
  methods: {
    cerrar: function () {
      var thisTemporal = this;

      thisTemporal.open = false;
      thisTemporal.$store.state.nuevoRegistro = false;
      console.log(thisTemporal.$store.state.nuevoRegistro);
    },
  },
  mounted: function () {},
};
</script>

<style lang="css" scoped>
  .contPrincipal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .nuevaCont {
    width: 90%;
    height: auto;
    background-color: #bad9d8;
    border-radius: 6px;
    box-shadow: 6px 3px 16px rgba(0, 0, 0, 0.16);
    z-index: 10;
    padding: 30px 0;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .nuevaCont img {
      width: 15px;
      height: 15px;
      margin-bottom: 20px;
      cursor: pointer;
    }


  .itemForm {
    width: 90%;
    margin-bottom: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .itemForm p 
  {
      margin: 0;
      font-size: 4.5vw;
      color: #4E4B4B;
      letter-spacing: 1px;
  }

  .itemForm input {
    width: 60%;
    height: 40px;
    border: none;
    border-bottom: 1px solid #fff;
    background: none;
    font-size: 4.5vw;
    color: #4E4B4B;
  }

  .itemForm select {
    width: 60%;
    height: 40px;
    border: none;
    border-bottom: 1px solid #fff;
    background: none;
    font-size: 4.5vw;
    letter-spacing: 1px;
    color: #4E4B4B;
  }

  .nuevaCont button {
    width: 65%;
    height: 30px;
    background-color: #fff;
    color: #4E4B4B;
    font-size: 4vw;
    border: none;
    border-radius: 10px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
    margin-top: 30px;
    letter-spacing: 1px;
    cursor: pointer;
  }
@media screen and (min-width: 768px) and (max-width: 1023px) 
{
  .nuevaCont
  {
    width: 80%;
    height: auto;
    padding: 40px 0;
  }

  .nuevaCont img 
  {
    width: 20px;
    height: 20px;
    margin-bottom: 30px;
  }

  .itemForm p 
  {
    font-size: 1.2em;
    letter-spacing: 1px;
  }

  .itemForm input 
  {
    height: 50px;
    font-size: 1.2em;
    letter-spacing: 1px;
  }

  .itemForm select 
  {
    font-size: 1.2em;
    letter-spacing: 1px;
  }

  .options
  {
    font-size: 1.2em;
    letter-spacing: 1px;
  }

  .nuevaCont button
  {
    width: 60%;
    font-size: 1.2em;
    height: 40px;
  }
}

@media screen and (min-width: 1024px) 
{
  .contPrincipal
  {
    width: 95%;
    left: 5%;
  }

  .nuevaCont
  {
    width: 40%;
    height: auto;
    padding: 30px 0;
  }

  .itemForm p 
  {
    font-size: 0.8em;
    letter-spacing: 1px;
  }

  .itemForm input 
  {
    height: 50px;
    font-size: 0.8em;
    letter-spacing: 1px;
  }

  .itemForm select 
  {
    font-size: 0.8em;
    letter-spacing: 1px;
  }

  .options
  {
    font-size: 0.8em;
    letter-spacing: 1px;
  }
  .nuevaCont button 
  {
    width: 55%;
    font-size: 0.8em;
  }

}
</style>
